import $ from 'jquery';
import axios from 'axios';

$(document).ready(function () {
    const $languageElement = $('.language-switch__language');

    $languageElement.click(function (event) {
        if ($(this).hasClass('language-switch__language--active')) {
            return false;
        }

        var payload = {
            contentLinkId: $('#contentLinkId').val(),
            language: $(this).attr('data-lang')
        };

        axios.post('/LanguageSelector/SetLanguage', payload).then(response => {
            window.location.href = response.data.returnUrl;
        }).catch(error => {
            console.error(error);
        });
    })
});
